import React, {Component} from 'react';
import {connect} from 'react-redux';
import VariablesForm from '../components/VariablesForm';
import {DATA_SETS} from '../Constants';
import {
  SUMMER_AFTERNOON_FMC_ENUM,
  SUMMER_AFTERNOON_FMC_USER_CONFIGURABLE
} from '../utils/behaviour_models/shared/ffm';
import './Forms.css';

const META_DATA = [
  {
    key: 'surface_hazard', displayName: 'Surface Fuel Hazard', row: 1, order: 2,
    enum: { 'Nil (0)': 0, 'Low (1)': 1, 'Moderate (2)': 2, 'High (3)': 3, 'Very High (3.5)': 3.5, 'Extreme (4)': 4 }
  },
  { key: 'slope', displayName: 'Slope (deg)', min: -90, max: 90, row: 1, order: 1 },
  {
    key: 'near_surface_hazard', displayName: 'Near-Surface Hazard', row: 2, order: 3,
    enum: { 'Nil (0)': 0, 'Low (1)': 1, 'Moderate (2)': 2, 'High (3)': 3, 'Very High (3.5)': 3.5, 'Extreme (4)': 4 }
  },
  { key: 'near_surface_height', displayName: 'Near-Surface Fuel Height (cm)', min: 0, max: 500, row: 2, order: 6 },
  {
    key: 'elevated_hazard', displayName: 'Elevated Fuel Hazard', row: 3, order: 4,
    enum: { 'Nil (0)': 0, 'Low (1)': 1, 'Moderate (2)': 2, 'High (3)': 3, 'Very High (3.5)': 3.5, 'Extreme (4)': 4 }
  },
  { key: 'elevated_height', displayName: 'Elevated Fuel Height (m)', min: 0, max: 99, row: 3, order: 7 },
  {
    key: 'bark_hazard', displayName: 'Bark Hazard', row: 4, order: 5,
    enum: { 'Nil (0)': 0, 'Low (1)': 1, 'Moderate (2)': 2, 'High (3)': 3, 'Very High (3.5)': 3.5, 'Extreme (4)': 4 }
  },
  {
    key: 'calculated_fuel_load', displayName: 'Calculated Fuel Load', row: 4, calculated: true
  },
  {
    key: 'lag_temp_rh', displayName: 'Lag Temp & RH', row: 5, order: 8,
    enum: { 'Off': 0, '2 Hrs': 2 }
  },
  // Summer afternoon FMC — hidden while SUMMER_AFTERNOON_FMC_USER_CONFIGURABLE is false.
  ...(SUMMER_AFTERNOON_FMC_USER_CONFIGURABLE ? [{
    key: 'summer_afternoon_fmc', displayName: 'Summer afternoon FMC', row: 5, order: 9,
    enum: SUMMER_AFTERNOON_FMC_ENUM,
    note: '1Only affects fine fuel moisture 1 Oct–31 Mar, 12:00–17:59.'
  }] : [])
];

class VestaVariables extends Component {
  render() {
    return <VariablesForm data_set={DATA_SETS.VESTA}
                          meta_data={META_DATA}
                          variables={this.props.variables}
                          dispatch={this.props.dispatch}/>;
  }
}

const mapStateToProps = state => {
  return {
    variables: {
      slope: state.point_data_vesta.slope,
      surface_hazard: state.point_data_vesta.surface_hazard,
      near_surface_hazard: state.point_data_vesta.near_surface_hazard,
      near_surface_height: state.point_data_vesta.near_surface_height,
      elevated_hazard: state.point_data_vesta.elevated_hazard,
      elevated_height: state.point_data_vesta.elevated_height,
      bark_hazard: state.point_data_vesta.bark_hazard,
      calculated_fuel_load: state.point_data_vesta.calculated_fuel_load,
      lag_temp_rh: state.point_data_vesta.lag_temp_rh,
      summer_afternoon_fmc: state.point_data_vesta.summer_afternoon_fmc
    }
  };
};

const mapDispatchToProps = dispatch => {
  return {
    dispatch: dispatch
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(VestaVariables);



// WEBPACK FOOTER //
// ./src/containers/VestaVariables.js